import React, { useEffect } from "react";
import "./cv.css";
import QRCode from "qrcode.react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const CV = () => {
  const currentTheme = localStorage.getItem("theme");

  useEffect(() => {
    const projetSelectElement = document.querySelector("cv");

    if (projetSelectElement) {
      if (currentTheme === "light") {
        projetSelectElement.classList.remove("dark-mode-details-cv");
        projetSelectElement.classList.add("light-mode-details-cv");
      } else {
        projetSelectElement.classList.remove("light-mode-details-cv");
        projetSelectElement.classList.add("dark-mode-details-cv");
      }
    }
  }, [currentTheme]);

  const cvFileName = "resume.pdf";
  return (
    <div className="cv">
      <div className="QR">
        <QRCode value="https://online.fliphtml5.com/gepop/colk/" />
      </div>
      <div className="QR">
        <a href={`/CV/${cvFileName}`} download>
          <FontAwesomeIcon icon={faDownload} /> Télécharger mon CV
        </a>
      </div>
    </div>
  );
};

export default CV;
